module.exports = __webpack_public_path__ + "img/weixingniang.4db8d171.png";